import { createContext, useContext } from 'react';

type TableListItemValueContextType = {
  hasHovered: boolean;
};

export const TableListItemValueContext = createContext<TableListItemValueContextType>({
  hasHovered: false,
});

export const useTableListItemValueContext = () => {
  return useContext(TableListItemValueContext);
};
